import * as React from "react";
import Menu from "./menu";
import Hero from "./hero";
import Main from "./main";
import Footer from "./footer";
import Favicon from "./favicon";
import { Helmet } from "react-helmet";
import { yourNameEn, yourNameJa } from "../util";
import { basicData } from "../data";
import { useLang } from "../lang";

const App: React.FC = () => {
  const { langEn, setLangEn } = useLang();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isNavOpen, setIsNavOpen] = React.useState(false);
  const handleLangSwitchClick = () => {
    setLangEn((prev) => !prev);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  React.useEffect(() => {
    const finishLoading = () => {
      window.setTimeout(() => setIsLoading(false), 300);
    };

    if (document.readyState === "complete") {
      finishLoading();
      return;
    }

    window.addEventListener("load", finishLoading, { once: true });
    return () => {
      window.removeEventListener("load", finishLoading);
    };
  }, []);

  React.useEffect(() => {
    document.body.classList.toggle("offcanvas", isNavOpen);
    return () => {
      document.body.classList.remove("offcanvas");
    };
  }, [isNavOpen]);

  return (
    <div id="colorlib-page">
      <div id="app-loading" className={isLoading ? "is-active" : ""} aria-hidden={!isLoading}>
        <div className="spinner"></div>
      </div>
      <Favicon />
      <Helmet>
        <title>{yourNameEn + " | " + yourNameJa}</title>
        <meta content={basicData.pageDescription} name="description" />
        <meta content={basicData.pageKeywords} name="keywords" />
      </Helmet>

      <a
        href="#"
        className={`js-colorlib-nav-toggle colorlib-nav-toggle${isNavOpen ? " active" : ""}`}
        aria-controls="colorlib-aside"
        aria-expanded={isNavOpen}
        onClick={(e) => {
          e.preventDefault();
          setIsNavOpen((prev) => !prev);
        }}
      >
        <i></i>
      </a>
      <Menu onNavigate={closeNav} />
      <Hero />
      <div id="colorlib-main">
        <Main />
        <Footer />
      </div>
      <div
        id="lang-switch-btn"
        role="group"
        aria-label="Language switch"
        onClick={handleLangSwitchClick}
      >
        <button
          type="button"
          className={`lang-option${langEn ? " selected" : ""}`}
          aria-pressed={langEn}
        >
          EN
        </button>
        <button
          type="button"
          className={`lang-option${langEn ? "" : " selected"}`}
          aria-pressed={!langEn}
        >
          JP
        </button>
      </div>
    </div>
  );
};

export default App;
